import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/exam-title.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-bf0c4ae4")

_pushScopeId("data-v-bf0c4ae4")
const _hoisted_1 = { class: "exam-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "exam-title",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "exam-timecount" }
const _hoisted_4 = { class: "exam-content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "question-content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "btn-group" }
const _hoisted_9 = { class: "flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShareBtn = _resolveComponent("ShareBtn")
  const _component_Confirm = _resolveComponent("Confirm")
  const _component_HomeModal = _resolveComponent("HomeModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, "倒计时：" + _toDisplayString(_ctx.timeStr), 1),
    _createVNode("div", _hoisted_4, [
      (_ctx.questions.length && _ctx.nowItem)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.nowIndex+1) + ".（" + _toDisplayString(_ctx.questionTypes[_ctx.nowItem.type]) + "）" + _toDisplayString(_ctx.nowItem['title']), 1),
              (_ctx.nowItem['file'])
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: _ctx.nowItem['file'],
                    alt: "banner",
                    class: "banner"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nowItem['options'], (option, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: ["option-item", {
                [_ctx.nowItem['type'] + `-active`]: _ctx.answer[_ctx.nowItem['id']] && _ctx.answer[_ctx.nowItem['id']].indexOf(index) > -1
            }],
                  key: index,
                  onClick: _withModifiers(($event: any) => (_ctx.chooseClick(index)), ["stop"])
                }, _toDisplayString(_ctx.optionLabel[index]) + " " + _toDisplayString(option), 11, ["onClick"]))
              }), 128))
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("button", {
                  class: "prev",
                  disabled: _ctx.nowIndex === 0,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevClick && _ctx.prevClick(...args)), ["stop"]))
                }, "上一道", 8, ["disabled"]),
                _createVNode("button", {
                  class: "next",
                  disabled: !_ctx.hasChoose || _ctx.nowIndex === _ctx.questions.length -1,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextClick && _ctx.nextClick(...args)), ["stop"]))
                }, "下一道", 8, ["disabled"])
              ]),
              _createVNode("button", {
                class: "submit-btn",
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)), ["stop"]))
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ShareBtn),
    (_ctx.showConfirm)
      ? (_openBlock(), _createBlock(_component_Confirm, {
          key: 0,
          showCancel: true,
          modalText: "确定结束答题？",
          onCancel: _ctx.confirmCancel,
          onSubmit: _ctx.confirmSubmit
        }, null, 8, ["onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_HomeModal, {
          key: 1,
          showCancel: true,
          modalText: _ctx.modalText,
          onSubmit: _ctx.modalSubmit,
          onCancel: _ctx.modalCancel,
          cancelText: "返回答题",
          submitText: "不填写，提交试卷"
        }, null, 8, ["modalText", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true)
  ]))
})